function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom'; // import { renderRoutes } from 'react-router-config';

import Loadable from 'react-loadable';
import './App.scss';

var loading = function loading() {
  return React.createElement("div", {
    className: "animated fadeIn pt-3 text-center"
  }, "Loading...");
}; // Containers


var DefaultLayout = Loadable({
  loader: function loader() {
    return new Promise(function (resolve) {
      require.ensure([], function (require) {
        resolve(require('./containers/DefaultLayout'));
      });
    });
  },
  loading: loading
}); // Pages

var Login = Loadable({
  loader: function loader() {
    return new Promise(function (resolve) {
      require.ensure([], function (require) {
        resolve(require('./views/Pages/Login'));
      });
    });
  },
  loading: loading
}); // Pages

var Codes = Loadable({
  loader: function loader() {
    return new Promise(function (resolve) {
      require.ensure([], function (require) {
        resolve(require('./views/Pages/Codes'));
      });
    });
  },
  loading: loading
});
var Register = Loadable({
  loader: function loader() {
    return new Promise(function (resolve) {
      require.ensure([], function (require) {
        resolve(require('./views/Pages/Register'));
      });
    });
  },
  loading: loading
});
var Page404 = Loadable({
  loader: function loader() {
    return new Promise(function (resolve) {
      require.ensure([], function (require) {
        resolve(require('./views/Pages/Page404'));
      });
    });
  },
  loading: loading
});
var Page500 = Loadable({
  loader: function loader() {
    return new Promise(function (resolve) {
      require.ensure([], function (require) {
        resolve(require('./views/Pages/Page500'));
      });
    });
  },
  loading: loading
});

var App =
/*#__PURE__*/
function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, _getPrototypeOf(App).apply(this, arguments));
  }

  _createClass(App, [{
    key: "render",
    value: function render() {
      return React.createElement(HashRouter, null, React.createElement(Switch, null, React.createElement(Route, {
        exact: true,
        path: "/register",
        name: "Register Page",
        component: Register
      }), React.createElement(Route, {
        exact: true,
        path: "/404",
        name: "Page 404",
        component: Page404
      }), React.createElement(Route, {
        exact: true,
        path: "/500",
        name: "Page 500",
        component: Page500
      }), React.createElement(Route, {
        path: "/main",
        name: "Home",
        component: DefaultLayout
      }), React.createElement(Route, {
        path: "/codes",
        name: "Login Page",
        component: Codes
      }), React.createElement(Route, {
        path: "/",
        name: "Login Page",
        component: Login
      })));
    }
  }]);

  return App;
}(Component);

export default App;